import React from "react";
import "./Home.css";
const Home = () => {
  return (
    <div>
      <h2>Home</h2>
    </div>
  );
};

export default Home;
